module.exports = __webpack_public_path__ + "static/media/undraw_teamwork_hpdk.d459cee0.svg";